export const ContractSolicitationStatus = {
	Requested: "requested",
	Production: "production",
	Adjustment: "adjustment",
	Validation: "validation",
	Creation: "creation",
	Finished: "finished"
};

export const contractSolicitationTypes = {
	other: "Other",
	nda: "Nda",
	confidentiality: "Confidentiality",
	loan: "Loan",
	serviceProvision: "ServiceProvision",
	addendum: "Addendum",
	termination: "Termination"
};

export const ContractTypeEnum = {
	OTHER: 0,
	NDA: 1,
	CONFIDENTIALITY: 2,
	LOAN: 3,
	SERVICE_PROVISION: 4,
	ADDENDUM: 5,
	TERMINATION: 6
};

export const contractTypeToNumeric = {
	other: ContractTypeEnum.OTHER,
	nda: ContractTypeEnum.NDA,
	confidentiality: ContractTypeEnum.CONFIDENTIALITY,
	loan: ContractTypeEnum.LOAN,
	serviceProvision: ContractTypeEnum.SERVICE_PROVISION,
	addendum: ContractTypeEnum.ADDENDUM,
	termination: ContractTypeEnum.TERMINATION
};

export const ContractSolicitationPriority = {
	Urgent: "urgent",
	High: "high",
	Medium: "medium",
	Low: "low"
};

export const PRIORITY_OPTIONS = [
	{ label: "Urgente", value: ContractSolicitationPriority.Urgent },
	{ label: "Alta", value: ContractSolicitationPriority.High },
	{ label: "Média", value: ContractSolicitationPriority.Medium },
	{ label: "Baixa", value: ContractSolicitationPriority.Low }
];

export const ContractSolicitationTier = {
	High: "high",
	Mid: "mid",
	Low: "low"
};
